import { render } from "./CustomNav.vue?vue&type=template&id=459c4604&scoped=true"
import script from "./CustomNav.vue?vue&type=script&lang=js"
export * from "./CustomNav.vue?vue&type=script&lang=js"

import "./CustomNav.vue?vue&type=style&index=0&id=459c4604&scoped=true&lang=css"

import exportComponent from "/Users/pushpan/Projects/WebApps/Python/Django/store_manage/punil/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-459c4604"]])

export default __exports__